import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotTopics from "./components/HotTopics";
import RankPanel from "./components/RankPanel";
import Discussion from "./components/Discussion";
import CommentsShowcase from "./components/CommentsShowcase";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-800">
      <Navbar />
      <Hero />
      <HotTopics />
      <RankPanel />
      <Discussion />
      <CommentsShowcase />
      <Faq />
      <About />
      <Newsletter />
      <Footer />
      <BackToTop />
    </main>
  );
}